import * as React from 'react';

type ActionFeedbackBackgroundCircleSvgProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
};

const ActionFeedbackBackgroundCircleSvg: React.FC<ActionFeedbackBackgroundCircleSvgProps> = ({
  width = 124,
  height = 124,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 124 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ActionFeedbackBackgroundCircleSvg"
      {...props}
    >
      <g filter="url(#filter0_bd_1764_10896)">
        <rect
          x="0"
          y="0"
          width="124"
          height="124"
          rx="62"
          fill="black"
          fillOpacity="0.66"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_bd_1764_10896"
          x="-23"
          y="-23"
          width="170"
          height="170"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="11.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1764_10896" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0" />
          <feBlend mode="normal" in2="effect1_backgroundBlur_1764_10896" result="effect2_dropShadow_1764_10896" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1764_10896" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default ActionFeedbackBackgroundCircleSvg;
